// Transaction-file presentation — minimal field surface for `transaction_files`.
//
// The TransactionDocuments section composes its own bucket UX over the rows;
// this schema lets `useRunListQuery` derive resource + SELECT + auto cache
// invalidation when sibling code (`useDocumentReview`, upload workflow)
// mutates the resource.

import type { TransactionFile } from "@shared/types/transaction";
import type { SchemaMeta } from "@ds/config/schema";
import { definePresentation } from "@ds/config/presentation";
import { asDataSchema } from "@ds/config/presentationRefs";

// Auto-generated from COLUMN_META for transaction_files — every scalar column
// (id, transaction_id, document_type, document_status, drive_file_id,
// file_name, is_latest, review_status, created_at, …) becomes a presentation
// field with the default cell display. No bespoke overrides — the
// TransactionDocuments + pipeline cells compose their own UX over the rows.
const presentation = definePresentation("transaction_files", {});

const META: SchemaMeta = {
  resource:            "transaction_files",
  writeResource:       "transaction_files",
  invalidateResources: ["transaction_files"],
  entityType:          "transaction_file",
  softDelete:          false,
  labels: {
    singular: (t) => t("documents.file.singular", "Plik"),
    plural:   (t) => t("documents.file.plural",   "Pliki"),
  },
  permanentFields: [
    "id", "transaction_id", "is_latest", "document_type",
    "document_status", "review_status", "drive_file_id", "file_name",
  ],
};

export const transactionFilePresentation = presentation;
export const transactionFileDataSchema = asDataSchema<TransactionFile>(presentation, META);
/** @deprecated Use transactionFileDataSchema */
export { transactionFileDataSchema as transactionFileSchema };
